import { getCurrentLocale } from "../../../localization"

const locale = getCurrentLocale();

export default {
    brandingFeatures: {
        logo_url: "vendor_telus-logo",
        app_name_prefix: "TELUS", // results in "TELUS | Raven Web" (combined with strings.app_name_suffix)
        theme_selection: "dark",
        splash_asset: "vendor-splash-asset_raven-cdn-telus_optimized.jpg"
    },
    buildFeatures: {
        show_billing: false,
        show_raven_external_id: true,
        integrations: true,
        facial_recognition: false,
        language_selection: true,
        global_settings: {
            section_available: true,
            audible_alerts: true,
            audio: false,
            daily_reports: true,
            driver_alerts: {
                section_available: true,
                audio_notifications: true // default is true, but overridden by section_available
            },
            gestures: false,
            video_quality: true, // default is true
            wifi_hotspot: true, // default is true
            events: {
                section_available: true
            }
        }
    },
    globals: {
        supportUrl: locale === 'fr' ? 
                'https://support.telus.ravenconnected.com/hc/fr-ca'
            :
                'https://support.telus.ravenconnected.com/hc/en-us',

        supportPhoneNumber: '1-866-273-3423',
        supportEmail: 'iot_coe@telus.com',
        salesEmail: 'iot_coe@telus.com',
        supportHoursDescriptionStringKey: 'contact_us_support_hours_description_vendor_custom_1',
        facialRecognitionBadgeStringKey: 'facial_recognition_badge_vendor_custom_1',
        ravenHomeUrl: null, // telus hides the ravenHome link in footer
        eulaUrl: 'http://legal.raven.is/TELUSWebAppEULA.htm',

        fleetManagersGuideUrl: locale === 'fr' ? 
                'https://support.telus.ravenconnected.com/hc/fr-ca/articles/4410727656471-Guide-du-gestionnaire-de-parc-de-v%C3%A9hicules-Raven'
            :
                'https://support.telus.ravenconnected.com/hc/en-us/articles/4410727656471-Fleet-Managers-Guide',

        installingRavenGuideUrl: 'https://telus.ravenconnected.com/installation',
        ravenHome: 'ravenconnected.com',
        buyRavenUrl: null,
        whatsNewUrl: locale === 'fr' ?
                'https://support.telus.ravenconnected.com/hc/fr-ca/articles/4406596331927-What-s-new'
            :
                'https://support.telus.ravenconnected.com/hc/en-us/articles/4406596331927-What-s-new',
    }
}